import { Box, Center, SkeletonText } from '@chakra-ui/react';
import React from 'react';
export class Bootstrapping extends React.Component {
    render() {
        return (React.createElement(Box, { padding: "6", boxShadow: "lg", bg: "white", w: '50%' },
            React.createElement(SkeletonText, { mt: "4", noOfLines: 4, spacing: "4", startColor: "pink.500", endColor: "orange.500" }),
            React.createElement(Center, { mt: '10px' },
                React.createElement("span", null, "Bootstapping LetrWing"))));
    }
}
